import React,{ Component } from "react";
import { connect } from "react-redux";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import BrandingConfigForm from "../BrandingConfigForm/BrandingConfigForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import {updateBrandingConfig} from "../../../actions/actionBranding";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Branding",path:"/branding",isActive: false},
    {name: "UpdateBranding",path:"/updatebranding",isActive: true},
];

class UpdateBrandingConfig extends Component{
    render(){
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Branding Config </strong>
                                </CardHeader>
                                <BrandingConfigForm
                                    updateBrandingConfig={this.props.updateBrandingConfig}
                                    brandingConfigId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateBrandingConfig.propTypes = {
    updateBrandingConfig: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
        branding_configs: state.branding.branding_configs || [],
    }),
    dispatch => ({
        updateBrandingConfig: (data) => dispatch(updateBrandingConfig(data))
    }))(UpdateBrandingConfig);


// WEBPACK FOOTER //
// ./src/views/Branding/UpdateBrandingConfig/UpdateBrandingConfig.js